export const dashboard = {
  welcome: "Welcome, {name}",
  descWithCrm: "Your follow-ups, key numbers, and work areas are below.",
  descBasic: "Your work areas are below.",
  kpi: {
    overdueFollowUps: "Overdue follow-ups",
    openQuotes: "Open quotes",
    atRiskJobs: "At-risk jobs",
    openJobIssues: "Open job issues",
    stockShortages: "Stock shortages",
    outstandingInvoices: "Outstanding invoices",
  },
  recentCash: "Recent cash activity",
  availableNow: "Available now",
  footer:
    "Customers, quoting, production, stock, cash, reports, and data import are live.",
  sliceNote: {
    quotes: "RFQ to accepted quote",
    jobs: "Job travelers",
    shopFloor: "Operator terminal",
    materials: "Stock ledger and buying",
    invoices: "Invoices and cash",
    reports: "Dashboards and exports",
  },
};
